import { useContext, useEffect, useRef } from "react";
import { CombinedContext } from "../context/combinedContext";
import { hasSession } from "./tokenManager";

/**
 * Drop any existing session on arrival at an invite page.
 *
 * These pages are reached from a link in an email, and that link is an identity
 * claim for one specific address. Whoever the browser happens to be signed in as
 * is not that person, so the app shell, the role-based navigation and every
 * authenticated request underneath would all be pointing at the wrong account.
 *
 * Deliberately latched to the first run rather than watching userData: the last
 * thing registration does is establish the *new* session while still on this
 * route, and a reactive version would tear that down the moment it appeared.
 */
export default function useSignOutOnEntry() {
	const { logout } = useContext(CombinedContext);
	const handled = useRef(false);

	useEffect(() => {
		if (handled.current) return;
		handled.current = true;

		/* hasSession reads storage rather than context so a session that is still
		   mid-restore at mount is caught too. */
		if (hasSession()) logout();
	}, [logout]);
}
